const baseCreditCardStyle = {
  fontFamily: 'Optimist',
  fontStyle: 'normal',
  fontWeight: '400',
  fontSize: '14px',
  lineHeight: '21px',
};

export default baseCreditCardStyle;
